module.exports = __webpack_public_path__ + "static/media/camera.b4fd8a2d.svg";